import React, {Suspense} from 'react';
import {Route, Router, Switch} from 'react-router-dom';

import {history} from 'core/history';

import {LoadingPage} from 'components/loading-page';
import {useAccountStore} from 'hooks/account-store';

import {Redirects} from './redirects';
import {LoginScreen} from './screens/login';
import PopupEditorApp from 'app-popup/app';

const Permissions = React.lazy(() => import('./screens/permissions'));
const WebEditorApp = React.lazy(() => import('./app-translator/app'));
const OfferEditorApp = React.lazy(() => import('./app-offer/app'));

const urlPrefix = process.env.REACT_APP_URL_PREFIX || '';

export function Apps() {
    const accountStore = useAccountStore();

    if (accountStore.loading) {
        return <LoadingPage/>;
    }

    if (!accountStore.loggedIn) {
        return <LoginScreen/>;
    }

    return (
        <Router history={history}>
            <Suspense fallback={<LoadingPage/>}>
                <Switch>
                    <Route path={`${urlPrefix}/permissions`} component={Permissions}/>
                    <Route path={`${urlPrefix}/website-editor`} component={WebEditorApp}/>
                    <Route path={`${urlPrefix}/offer-editor`} component={OfferEditorApp}/>
                    <Route path={`${urlPrefix}/popup-editor`} component={PopupEditorApp}/>
                    <Route path={urlPrefix} component={Redirects}/>
                </Switch>
            </Suspense>
        </Router>
    );
}